import type React from 'react'

import { SwitchNormal, SwitchThin } from './components'
import type { Props } from './types'

const Switch: React.FC<Props> = (props) => {
  switch (props.mode) {
    case 'normal':
      return <SwitchNormal {...props} />

    default:
      return <SwitchThin {...props} />
  }
}

export default Switch
